// API Configuration - Environment-based URL switching
import { config } from './environment';

// Backend URLs - now using environment configuration
export const BACKEND_URLS = {
  development: config.apiBaseUrl,
  production: config.apiBaseUrl
};

export const API_BASE_URL = config.apiBaseUrl;
export const API_BASE_URL_WITH_VERSION = `${config.apiBaseUrl}/api`;

// Socket URL - now using environment configuration
export const SOCKET_URL = config.socketUrl;

// Default API configuration
export const API_CONFIG = {
  baseURL: API_BASE_URL_WITH_VERSION,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Environment-specific configurations
export const getApiConfig = () => {
  const isDev = config.appEnv === 'development';
  
  return {
    ...API_CONFIG,
    baseURL: isDev ? 'http://localhost:3000/api' : `${config.apiBaseUrl}/api`,
    timeout: isDev ? 60000 : 30000, // Longer timeout for development
  };
};

// Log the configuration for debugging
if (config.enableLogging) {
  console.log('🌐 API Configuration:', {
    environment: config.appEnv,
    isDevelopment: config.appEnv === 'development',
    backendUrl: config.apiBaseUrl,
    apiBaseUrl: API_BASE_URL_WITH_VERSION,
    socketUrl: config.socketUrl,
  });
}
